// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".portal-theme.theme--light.v-text-field[data-v-01a2f7a7]:not(.v-input--has-state){color:#579fa7!important}", ""]);
// Exports
module.exports = exports;
